import { Axios, AxiosError, AxiosResponse } from 'axios'
import { RemoteConfig } from './remote.config'

export class MyUserData {
	id: string;
	name: string;
	email: string;
	phone: string;

	constructor(id: string, name: string, email: string, phone: string) {
		this.id = id;
		this.name = name;
		this.email = email;
		this.phone = phone;
	}
}

export type MyUserCallback = (resp?: AxiosResponse, err?: AxiosError) => void;

export const getMyUser = (callback: MyUserCallback) => {
	const client = new Axios();
	const url = new URL("/api/v0/users/me", RemoteConfig.url);
	const result = client.get(url.toString(), {withCredentials:true}).then((resp) => {
		callback(resp)
	})
}
